// Clickwrap client. The three documents are public; accepting them is not.
import { apiGet, apiPost, backendBase } from '../utils/backendApi';

export async function fetchAgreements() {
  const base = backendBase();
  if (!base) throw new Error('Backend API not configured');
  const res = await fetch(`${base}/legal/agreements`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return Array.isArray(data.agreements) ? data.agreements : [];
}

export function legalStatus(orgId) {
  const q = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return apiGet(`/legal/status${q}`);
}

export function acceptLegal({ scope, orgId, docIds }) {
  return apiPost('/legal/accept', { scope, orgId, docIds, scrolled: true });
}
